import { useCallback, useContext } from 'react';
import STORE from '../../../../store';
import AccountPickerContext from '../../../../contexts/AccountPickerContext';
import isPerformanceBoard from '../../../../isPerformanceBoard';
import isCustomerLaneBoard from '../../../../isCustomerLaneBoard';
import updateBoard from '../../../../api/boards/updateBoard';

const useMarkBoardAsFilteredByEntity = () => {
  const { accountRef } = useContext(AccountPickerContext);
  const { selectedAccountId } = useContext(AccountPickerContext);

  const markBoardAsFilteredByEntity = useCallback(
    (board: PerformanceBoardTypes.Board | CustomerLaneBoard) => {
      if (isPerformanceBoard(board)) {
        const newBoard: PerformanceBoardTypes.Board = {
          ...board,
          isEntityFilterEnabled: true,
        };

        return STORE.contentDistributions
          .getPerformanceBoardsRef({ accountId: selectedAccountId })
          .doc(newBoard.id)
          .set(newBoard);
      }

      if (isCustomerLaneBoard(board)) {
        const newBoard: CustomerLaneBoard = {
          ...board,
          isEntityFilterEnabled: true,
        };

        return updateBoard(newBoard, accountRef);
      }

      alert('Something went wrong!');
      const e = new Error();
      e.name = 'useMarkBoardAsFilteredByEntity: Unexpected board type found';
      throw e;
    },
    [accountRef, selectedAccountId],
  );

  return markBoardAsFilteredByEntity;
};

export default useMarkBoardAsFilteredByEntity;
